import { getValueReduxUtil } from '../../../modules/redux/utils/get-value'

function getProfileIdModelUtil (instance) {
  return getValueReduxUtil(
    instance, 'profileId'
  )
}

export {
  getProfileIdModelUtil
}
